// extracted by mini-css-extract-plugin
module.exports = {"sideBar":"sidebar_sideBar__1LcAZ","fixed":"sidebar_fixed__2oUc5","icon":"sidebar_icon__2sE6B","sidebarItem":"sidebar_sidebarItem__nuQf2","active":"sidebar_active__3zkn6"};